import React from 'react';
import { ComponentProps, deps, inject, observer } from '../../../../lib/component';
import { FindSortMode, FindSortOrder } from '../../../../graphql/generated-types/graphql';
import { StyledSelect } from '../StyledSelect';
import { style } from 'typestyle';

export interface SortOption {
  label: string;
  value: {
    sortMode: FindSortMode;
    sortOrder: FindSortOrder;
  };
}

export const sortOptions: SortOption[] = [
  {
    label: 'Global Popularity',
    value: {
      sortMode: FindSortMode.PopularSpotify,
      sortOrder: FindSortOrder.Desc,
    },
  },
  {
    label: 'Popular on Lickd',
    value: {
      sortMode: FindSortMode.PopularLickd,
      sortOrder: FindSortOrder.Desc,
    },
  },
  {
    label: 'Recently Added',
    value: {
      sortMode: FindSortMode.RecentlyAdded,
      sortOrder: FindSortOrder.Desc,
    },
  },
  {
    label: 'Alphabetical Z-A',
    value: {
      sortMode: FindSortMode.Alphabetical,
      sortOrder: FindSortOrder.Desc,
    },
  },
  {
    label: 'Alphabetical A-Z',
    value: {
      sortMode: FindSortMode.Alphabetical,
      sortOrder: FindSortOrder.Asc,
    },
  },
];

export const SortDropdown: React.FC<ComponentProps> = inject(deps)(
  observer(
    ({
      model: {
        page: {
          searchMvp: {
            searchState: { sortMode, sortOrder },
          },
        },
      },
      controller: {
        page: {
          searchMvp: { refineSort },
        },
      },
    }) => {
      const handleChangeOrder = (sortOption: SortOption) => {
        refineSort(sortOption.value.sortMode, sortOption.value.sortOrder);
      };

      const selectedSortOption = sortOptions.find(
        (option) => option.value.sortMode === sortMode && option.value.sortOrder === sortOrder
      );

      return (
        <StyledSelect
          aria-label="Sort order"
          inputId="sort_order"
          name="sort_order"
          options={sortOptions}
          value={selectedSortOption}
          onChange={handleChangeOrder}
          className={style({ width: '200px' })}
        />
      );
    }
  )
);
